import React, { useContext } from 'react';
import { ThemeContext } from '@emotion/core';
import { Heading } from '@qga/roo-ui/components';

import PackageOptionContent from '../PackageOptionContent';

interface Props {
  title: string;
  isBestAvailableRate?: boolean;
}

const PackageOptionHeading = ({ title, isBestAvailableRate }: Props) => {
  const {
    components: { packageOption },
  } = useContext<{
    components: {
      packageOption: {
        bestAvailable: object;
        offer: object;
      };
    };
  }>(ThemeContext as any);

  const packageOptionElement =
    packageOption[isBestAvailableRate ? 'bestAvailable' : 'offer'];

  return (
    <PackageOptionContent {...packageOptionElement} pb={0}>
      <Heading.h4
        {...packageOptionElement}
        fontSize={['22px', null, '28px']}
        lineHeight={['33px', null, '40px']}
        paddingTop={'40px'}
      >
        {title}
      </Heading.h4>
    </PackageOptionContent>
  );
};

export default PackageOptionHeading;
